<template>
  <div class="hairdressing-form">
    <el-form
      ref="form"
      :model="form"
      size="small"
      label-position="left"
      style="display: flex;flex-direction: column;width: 100%"
    >
      <div class="select-sign-wrap" v-if="false">
        <div class="item">
          <el-form-item>
            <div class="form-item-content">
              <div class="item-label">标记序号</div>
              <div class="item-con">
                <el-select
                  v-model="form.signNumber"
                  placeholder="请选择"
                  @change="selectSign"
                >
                  <el-option
                    v-for="item in signNumberOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="item">
          <div class="btn add-sign-btn" @click="addSign">选择影像添加标记</div>
        </div>
      </div>
      <div class="select-sign-wrap info-head-wrap" v-if="!quickInputModel()">
        <div class="item">
          <el-form-item>
            <div class="form-item-content">
              <div class="item-label">治疗设备/方法</div>
              <div class="item-con">
                <el-select v-model="form.device" placeholder="请选择" @change="selectDeviceItem">
                  <el-option
                    v-for="item in deviceOptions"
                    :key="item.id"
                    :label="item.device_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="item">
          <el-form-item>
            <div class="form-item-content">
              <div class="item-label">治疗模块/药物</div>
              <div class="item-con">
                <el-select v-model="form.treatmentModule" placeholder="请选择" @change="selectTreatmentModuleItem">
                  <el-option
                    v-for="item in treatmentModuleOptions"
                    :key="item.id"
                    :label="item.module_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>

    <div class="select-sign-wrap info-head-wrap" v-else>
      <div class="item">
        <el-form-item>
            <div class="form-item-content">
              <div class="item-label">快捷检索：</div>
            </div>
        </el-form-item>
      </div>
    </div>  


      <div class="info-wrap" v-show="form.treatmentModule">
        <div class="info-box">
          <div class="info-item" v-for="(item, index) in infoParamsList" :key="index">
            <el-form-item>
              <div class="form-item-content">
                <div class="item-label">{{item.label}}</div>
                <div class="item-con">
                  <el-input v-model="item.value"></el-input>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="save-btn-box">
          <button
            class="btn"
            v-show="infoParamsList.length"
            @click.prevent="confirm"
          >保存</button>
        </div>
      </div>
      <div class="select-template-wrap" v-show="hairdressingInfoData.selectedTypeTabData && !form.device &&
      !form.treatmentModule">
        <div
          class="select-item"
          v-for="(item, index) in deviceOptions"
          :key="index"
          @click="selectDeviceItemByCard(item.id,index)"
        >{{item.device_name}}</div>
      </div>
      <div class="select-template-wrap" v-show="hairdressingInfoData.selectedTypeTabData && form.device &&
      !form.treatmentModule">
        <div
          class="select-item select-item-template"
          v-for="(item, index) in treatmentModuleOptions"
          :key="index"
          @click="selectTreatmentModuleItemByCard(item.id)"
        >{{item.module_name}}</div>
      </div>
    </el-form>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import {computed} from 'vue';

  export default {
    
    inject: {
      commonData: ['commonData'],
      hairdressingInfoData: ['hairdressingInfoData'],
      getImageInfo: ['getImageInfo'],
      quickInputModel: ['quickInputModel'], // 从父组件传进的参数，是否打开快捷输入；暂时未用；2024-12-31
    },
    
    data() {
      return {
        form: {
          signNumber: '',
          device: '',
          treatmentModule: '',

          // 只用于快捷输入时，
          device_id: '',
          treatmentModule_id: '',

        },
        infoParamsList: [],
        signNumberOptions: [],
        selectedDeviceItemId: -1,
        selectedTreatmentModuleItemId: null,
        // 治疗信息创建后的id
        cosmetologyTreatDetailId: -1,
        deviceOptionsList:[],
      };
    },
    
    computed: {
      // 用于下拉列表或者平铺展示
      deviceOptions() {
        // console.log("In deviceOptions,hairdressingInfoData.selectedTypeTabData:", this.hairdressingInfoData.selectedTypeTabData);
        if (this.hairdressingInfoData.selectedTypeTabData) {
          this.deviceOptionsList = this.hairdressingInfoData.selectedTypeTabData.device;
          // console.log("deviceOptions:",this.hairdressingInfoData.selectedTypeTabData.device);
          return this.hairdressingInfoData.selectedTypeTabData.device;
        } else {
          this.deviceOptionsList = [];
          return []
        }
        
      },
      // 用于下拉列表或者平铺展示
      treatmentModuleOptions() {
        if (this.selectedDeviceItemId > -1) {
          const filterArr = this.deviceOptions.filter((item) => item.id === this.selectedDeviceItemId);
          if (filterArr[0]) {
            // console.log("treatmentModuleOptions:",filterArr[0].treat_module);
            return filterArr[0].treat_module;
          } else {
            return [];
          }
        }
      },
    },
    
    // watch: {
    //   'deviceOptions':function () {
    //    /* this.form.device = '';
    //     this.selectedDeviceItemId = -1;
    //     this.form.treatmentModule = '';
    //     this.infoParamsList = [];
    //     if (this.deviceOptions.length == 1){
    //       let deviceItem = this.deviceOptions[0]
    //       if(this.hairdressingInfoData.selectedTypeTabData.item_name == deviceItem.device_name){
    //         this.selectDeviceItemByCard(deviceItem.id,0)
    //       }
    //     }*/
    //   }
    //   /*async 'commonData.selectedImageData'(val) {
    //     if (val) {
    //       await this.getSignList(val.id);
    //       if (this.hairdressingInfoData.selectedTypeTabData) {
    //         this.showDetailsInfo();
    //       }
    //     }
    //   },*/
    // },
    
    methods: {
      selectDeviceItem(item) {
        this.selectedDeviceItemId = item;
      },
      selectDeviceItemByCard(item,index) {
        let dItem = this.deviceOptions[index];   
        this.selectedDeviceItemId = item;
        this.form.device = item;
        if (dItem.treat_module.length === 1){
            if (dItem.device_name === dItem.treat_module[0].module_name){
              this.selectTreatmentModuleItemByCard(dItem.treat_module[0].id)
            }
        }
        // console.log("selectDeviceItemByCard, form.device:",this.form.device);
      },
      selectTreatmentModuleItem(item) {        
        this.selectedTreatmentModuleItemId = item;
        this.form.treatmentModule = item;
        // console.log("selectTreatmentModuleItem, form.treatmentModule:",this.form.treatmentModule);
        this.handleInfoList(item);
      },
      selectTreatmentModuleItemByCard(item) {
        this.selectedTreatmentModuleItemId = item;
        this.form.treatmentModule = item;
        // console.log("selectTreatmentModuleItemByCard, form.treatmentModule:",this.form.treatmentModule);
        this.handleInfoList(item);
      },
      // 查找标点信息
      async getSignList(id) {
        const infoArr = await this.getImageInfo(id);
        if (infoArr) {
          this.commonData.imageInfo = infoArr;
        } else {
          this.commonData.imageInfo = [];
        }
      },
      // 生成参数信息列表 infoParamsList
      async handleInfoList(id) {
        const filterArr = this.treatmentModuleOptions.filter((item) => item.id === id);
        this.infoParamsList = filterArr[0].params.split('#').map((item) => ({label: item, value: ''}));
        this.infoParamsList = this.infoParamsList.filter(item =>{
          if (item.label!==""){
              return item
          }
        })
        // console.log(this.infoParamsList)
      },
      confirm() {
        // console.log("confirm, form:",this.form);
        if (!this.hairdressingInfoData.selectedParNum.id) { // 新增
          this.addCosmetologyTreatDetail();
        } else { // 编辑
          this.modifyCosmetologyTreatDetail();
        }
      },
      // 新增保存信息
      async addCosmetologyTreatDetail() {
        if (this.commonData.patientId === -1) {
          this.$message.error('请添加患者信息');
          return;
        }
        if (this.commonData.treat_no === '') {
          this.$message.error('请添加相关信息');
          return;
        }
        const variables = {
          patient_id: this.commonData.patientId,
          treat_no: this.commonData.treat_no,
          item_id: this.hairdressingInfoData.selectedTypeTabData.id,
          image_id: -1,
          sign_no: '',
          device_id: this.form.device,
          module_id: this.form.treatmentModule,
          param_value: JSON.stringify(this.infoParamsList),
          detail_title: this.hairdressingInfoData.selectedParNum.number,
          parent_id: this.commonData.parent_id,
        };
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`mutation(
              $patient_id: Int!
              $treat_no: String!
              $item_id: Int!
              $image_id: Int!
              $sign_no: String!
              $device_id: Int!
              $module_id: Int!
              $param_value: String!
              $detail_title: String!
              $parent_id: String!
            ){
              addCosmetologyTreatDetail(
                patient_id: $patient_id
                treat_no: $treat_no
                item_id: $item_id
                image_id: $image_id
                sign_no: $sign_no
                device_id: $device_id
                module_id: $module_id
                param_value: $param_value
                detail_title: $detail_title
                parent_id: $parent_id
              ){
                id
                item_id
                device_id
                module_id
                param_value
              }
            }`,
            variables,
          });
          this.$message({
            type: "success",
            message: "保存成功"
          });
          const data = res.data.addCosmetologyTreatDetail;
          this.hairdressingInfoData.selectedParNum.id = data.id;
          this.hairdressingInfoData.selectedParNum.item_id = data.item_id;
          this.hairdressingInfoData.selectedParNum.device_id = data.device_id;
          this.hairdressingInfoData.selectedParNum.module_id = data.module_id;
          this.hairdressingInfoData.selectedParNum.param_value = data.param_value;
          // console.log("addCosmetologyTreatDetail success, hairdressingInfoData:",this.hairdressingInfoData);
          // this.$root.$emit('refreshCosmetParaDigest');
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 编辑信息
      async modifyCosmetologyTreatDetail() {
        if (this.commonData.patientId === -1) {
          this.$message.error('请添加患者信息');
          return;
        }
        if (this.commonData.treat_no === '') {
          this.$message.error('请添加相关信息');
          return;
        }
        const variables = {
          id: this.hairdressingInfoData.selectedParNum.id,
          patient_id: this.commonData.patientId,
          treat_no: this.commonData.treat_no,
          item_id: this.hairdressingInfoData.selectedTypeTabData.id,
          image_id: -1,
          sign_no: '',
          device_id: this.form.device,
          module_id: this.form.treatmentModule,
          param_value: JSON.stringify(this.infoParamsList),
          detail_title: this.hairdressingInfoData.selectedParNum.number,
        };
        try {
          const res = await this.$apollo.mutate({
            mutation: gql`mutation(
              $id: Int!
              $patient_id: Int
              $treat_no: String
              $item_id: Int
              $image_id: Int
              $sign_no: String
              $device_id: Int
              $module_id: Int
              $param_value: String
              $detail_title: String
            ){
              modifyCosmetologyTreatDetail(
                id: $id
                patient_id: $patient_id
                treat_no: $treat_no
                item_id: $item_id
                image_id: $image_id
                sign_no: $sign_no
                device_id: $device_id
                module_id: $module_id
                param_value: $param_value
                detail_title: $detail_title
              ){
                id
                item_id
                device_id
                module_id
                param_value
              }
            }`,
            variables,
          });
          this.$message({
            type: "success",
            message: "保存成功"
          });
          const data = res.data.modifyCosmetologyTreatDetail;
          this.hairdressingInfoData.selectedParNum.id = data.id;
          this.hairdressingInfoData.selectedParNum.item_id = data.item_id;
          this.hairdressingInfoData.selectedParNum.device_id = data.device_id;
          this.hairdressingInfoData.selectedParNum.module_id = data.module_id;
          this.hairdressingInfoData.selectedParNum.param_value = data.param_value;
          // console.log("modifyCosmetologyTreatDetail success, hairdressingInfoData:",this.hairdressingInfoData);
          // this.$root.$emit('refreshCosmetParaDigest');
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },

      // 接收来自父组件的切换项目Tab信号后，显示对应的设备、模块详情
      showDetailsInfo() {
        let isNewParam = true;
        if (this.hairdressingInfoData.selectedParNum.id) {

          // 有参数信息
          if (this.hairdressingInfoData.selectedTypeTabData) {

            if (this.hairdressingInfoData.selectedParNum.item_id === this.hairdressingInfoData.selectedTypeTabData.id) {

              // 匹配到方法
              this.form.device = this.hairdressingInfoData.selectedParNum.device_id;
              this.selectedDeviceItemId = this.hairdressingInfoData.selectedParNum.device_id;
              this.form.treatmentModule = this.hairdressingInfoData.selectedParNum.module_id;
              this.infoParamsList = JSON.parse(this.hairdressingInfoData.selectedParNum.param_value);
              isNewParam = false;
            } else {

              // 没有匹配到
              this.form.device = '';
              this.selectedDeviceItemId = -1;
              this.form.treatmentModule = '';
              this.infoParamsList = [];
            }
          } else {

            // 没有匹配到
            this.form.device = '';
            this.selectedDeviceItemId = -1;
            this.form.treatmentModule = '';
            this.infoParamsList = [];
          }
        } else {

          // 没有参数信息
          this.form.device = '';
          this.selectedDeviceItemId = -1;
          this.form.treatmentModule = '';
          this.infoParamsList = [];
        }
        if (isNewParam === true){
          if (this.deviceOptions.length === 1){
            let deviceItem = this.deviceOptions[0]
            if(this.hairdressingInfoData.selectedTypeTabData.item_name === deviceItem.device_name){
              this.selectDeviceItemByCard(deviceItem.id,0)
            }
          }
        }

        /*if (this.commonData.imageInfo.length) {
          const filterArr = this.commonData.imageInfo.filter((item) => item.item_id ===
            this.hairdressingInfoData.selectedTypeTabData.id);
          const signNumberOptions = [];
          for (const item of filterArr) {
            if (item.sign_no.split("-").length === 2) {
              item.label = '全部';
              item.value = item.sign_no;
              signNumberOptions.push(item);
            } else {
              item.label = item.sign_no;
              item.value = item.sign_no;
              signNumberOptions.push(item);
            }
          }
          if (signNumberOptions.length) {
            this.signNumberOptions = signNumberOptions;
            this.form.signNumber = signNumberOptions[0].value;
            
            // 有标点或全部就显示信息
            this.form.device = signNumberOptions[0].device_id;
            this.selectedDeviceItemId = signNumberOptions[0].device_id;
            this.form.treatmentModule = signNumberOptions[0].module_id;
            this.infoParamsList = JSON.parse(signNumberOptions[0].param_value);
            this.cosmetologyTreatDetailId = signNumberOptions[0].id;
            
            
          } else {
            this.signNumberOptions = [
              {
                label: '全部',
                value: this.hairdressingInfoData.selectedTypeTabData.id +  '-0',
              }
            ];
            this.form.signNumber = this.hairdressingInfoData.selectedTypeTabData.id +  '-0';
            this.form.device = '';
            this.selectedDeviceItemId = -1;
            this.form.treatmentModule = '';
            this.infoParamsList = [];
            this.cosmetologyTreatDetailId = -1;
          }
        } else {
          this.signNumberOptions = [
            {
              label: '全部',
              value: this.hairdressingInfoData.selectedTypeTabData.id +  '-0',
            }
          ];
          this.form.signNumber = this.hairdressingInfoData.selectedTypeTabData.id +  '-0';
          this.form.device = '';
          this.selectedDeviceItemId = -1;
          this.form.treatmentModule = '';
          this.infoParamsList = [];
          this.cosmetologyTreatDetailId = -1;
        }*/
      },
      // 显示大图添加标记
      addSign() {
        if (this.commonData.selectedImageData) {
          this.$root.$emit('addSign-showImage', {
            imgPath: this.commonData.selectedImageData.path,
            imgItem: this.commonData.selectedImageData,
            id: this.commonData.selectedImageData.id,
            type: 'hairdressing',
          });
        } else {
          this.$message.error('请选择图片');
          this.commonData.isClickAddSign = true;
        }
      },

      // 选择点
      selectSign(signNumber) {
        const filterArr = this.commonData.imageInfo.filter((item) => item.sign_no === signNumber);
        this.form.device = filterArr[0].device_id;
        this.selectedDeviceItemId = filterArr[0].device_id;
        this.form.treatmentModule = filterArr[0].module_id;
        this.infoParamsList = JSON.parse(filterArr[0].param_value);
        this.cosmetologyTreatDetailId = filterArr[0].id;
      },

      // 处理由父组件传来的快捷输入项目信息
      handleFullItemInfo(){
        // console.log("quickSelectedItem:", this.hairdressingInfoData.quickSelectedItem);        
        this.form.item_id = this.hairdressingInfoData.quickSelectedItem.item_id;
        this.form.device = this.hairdressingInfoData.quickSelectedItem.device_id;
        this.form.treatmentModule = this.hairdressingInfoData.quickSelectedItem.module_id;

        this.selectedDeviceItemId = this.hairdressingInfoData.quickSelectedItem.device_id;
        this.selectedTreatmentModuleItemId = this.hairdressingInfoData.quickSelectedItem.module_id;

        // 处理参数信息        
        this.infoParamsList = this.hairdressingInfoData.quickSelectedItem.params.split('#').map((item) => ({label: item, value: ''}));
        this.infoParamsList = this.infoParamsList.filter(item =>{
            if (item.label!==""){
                return item
            }
        })

      },      
    },
    
    watch: {
      // async 'commonData.cosmetologyTree'() {
      // },
      // async 'quickInputModel'(val){
      //   console.log("In commonHairessingForm, quickInputModel vale changed:",this.quickInputModel);
      // }
    },

    async mounted() {
      const quickInputModel = this.quickInputModel()

      // console.log("In commonHairessingForm, mounted, quickInputModel:", quickInputModel)
      // 接收来自父组件的切换项目Tab信号
      this.$root.$on('selectTypeTab', () => {
        /*if (this.commonData.selectedImageData) {
          this.getSignList(this.commonData.selectedImageData.id);
        }*/
        this.showDetailsInfo();
  
      /*  if (this.deviceOptions.length == 1){
          let deviceItem = this.deviceOptions[0]
          if(this.hairdressingInfoData.selectedTypeTabData.item_name == deviceItem.device_name){
            this.selectDeviceItemByCard(deviceItem.id,0)
          }
        }*/
      });
      // 接收来自父组件的快捷输入项目信息信号
      this.$root.$on('quickSelectedItem', () => {
        // console.log("Recv signal quickSelectedItem.")
        this.handleFullItemInfo();
      });

      /*this.$root.$on('refresh-cosmetology-info', async () => {
        if (this.commonData.selectedImageData) {
          await this.getSignList(this.commonData.selectedImageData.id);
          if (this.hairdressingInfoData.selectedTypeTabData) {
            this.showDetailsInfo();
          }
        }
      });*/
    },
    
    beforeDestroy() {
      this.$root.$off('selectTypeTab');
      this.$root.$off('quickSelectedItem');      
      // this.$root.$off('refresh-cosmetology-info');
    },
    
    filters: {
      formatConfirmText(id) {
        return id === -1 ? '保存' : '编辑';
      },
    },
    
  }
</script>

<style>
  .hairdressing-form .el-form-item{
    margin-bottom: 10px;
  }
  .hairdressing-form .el-select{
    width: 100%;
  }
</style>
<style lang="less" scoped>
  .hairdressing-form{
    width: 100%;
    height: 100%;
    .select-sign-wrap{
      display: flex;
      height: 40px;
      min-height: 40px;
      border-bottom: 2px solid #DADBDD;
      .item{
        flex: 1;
        padding: 0 10px;
        .add-sign-btn{
          width: 112px;
          height: 18px;
          margin-top: 1px;
          font-size: 14px;
        }
      }
    }
    .info-head-wrap{
      height: 52px;
      min-height: 52px;
      padding-top: 8px;
      box-sizing: border-box;
    }
    .info-wrap{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      .info-box{
        display: flex;
        flex-wrap: wrap;
        padding-top: 10px;
      
        .info-item{
          width: 50%;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
      .save-btn-box{
        display: flex;
        justify-content: flex-end;
        padding-right: 10px;
        padding-bottom: 10px;
      }
    }
    .select-template-wrap{
      display: flex;
      flex-wrap: wrap;
      flex: 1;
      padding: 10px;
      .select-item{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 120px;
        box-sizing: border-box;
        color: #fff;
        margin-right: 28px;
        margin-bottom: 20px;
        padding: 10px;
        border-radius: 20px;
        background-color: #9FC8E3;
        border: 1px solid rgb(153,176,189);
        box-shadow: 2px 2px 3px 0 #afafaf;
        font-size: 22px;
        font-weight: bold;
        word-break: break-all;
        user-select: none;
        cursor: pointer;
      }
      .select-item.select-item-template{
        background-color: rgb(233,175,63);
      }
    }
    .form-item-content{
      display: flex;
      .item-label{
        display: flex;
        align-items: center;
        width: 100px;
        margin-right: 10px;
        font-weight: bold;
        line-height: 14px;
        word-break:break-all;
      }
      .item-con{
        flex: 1;
      }
    }
  }
</style>
